<template>
  <div class="wrappers" ref="wrappers">
    <LiveVerticalVideo :errorInfor="liveErrorInfor" :src="toHttps(liveData.live_info.m3u8_url)" />
    <!-- 直播头部 -->
    <div class="live-header">
      <div class="left">
        <div class="teacher">
          <img :src="liveData.anchor_info.portrait" class="img" />
          <div class="text">{{ liveData.anchor_info.name }}</div>
        </div>
      </div>
      <div class="right">
        <!-- <OpenApp unitKey='CourseDetail' :options="{ no: liveData.course_no }">
                    <div class="button">APP内打开</div>
                </OpenApp> -->
      </div>
    </div>

    <ChatListVertical ref="ChatListVertical" :chatList="chatList" class="chat-list" />

    <!-- 底部操作栏（礼物 提问 购物车） -->
    <BottomActionbar
      ref="BottomActionbar"
      v-if="!isMpOppen"
      :theme="2"
      :showCar="!!liveData.live_info.s_no"
      :showCustomer="!!liveData.customer_info"
      :showGift="!!liveData.lotteryInfo"
      @onZan="showAppSheetText('zan')"
      @onCar="showAppSheetText('car')"
      @onQuestion="showAppSheetText('question')"
      @onCustomer="toURL(liveData.customer_info)"
      @onGift="showAppSheetText('gift')"
    />

    <!-- 引导app行动面板-->
    <ActionSheetApp
      ref="ActionSheetApp"
      :text="appSheetText"
      unitKey="CourseDetail"
      :options="{ no: liveData.course_no }"
    />
  </div>
</template>
<script>
import minxinTim from '../mixins/minxinTim'
import LiveActionbar from '@/components/Playing/LiveActionbar.vue'
import BottomActionbar from '@/components/Playing/BottomActionbar.vue'
import ChatListVertical from '@/components/Playing/ChatListVertical.vue'
import ActionSheetApp from '@/components/Playing/ActionSheetApp.vue'
import LiveVerticalVideo from '@/components/Video/LiveVerticalVideo.vue'
import { getRequestAppType } from '@/utils/cookies'
export default {
  props: {
    liveData: Object,
    liveStatus: Number,
  },
  mixins: [minxinTim],
  data() {
    return {
      appSheetTextKey: '',
      chatListHeight: 0, //聊天区域高度

      isOnlyTeacher: false,
    }
  },
  components: {
    LiveVerticalVideo,
    LiveActionbar,
    BottomActionbar,
    ChatListVertical,
    ActionSheetApp,
  },
  computed: {
    appSheetText() {
      const list = {
        zan: '给老师点赞',
        car: '选购直播商品',
        question: '参与聊天互动',
        gift: '参与直播抽奖',
        handout: '查看直播讲义',
      }
      const text = list[this.appSheetTextKey]

      return `请前往${this.getCurrentBrand.name}APP，${text}`
    },
    liveErrorInfor() {
      const result = {}
      result.title = this.liveData.nostart.centralCourseName
      result.time = this.liveData.nostart.centralCourseLiveTime
      result.teacher = this.liveData.anchor_info.name
      result.liveText = ''

      // 直播状态 0未开始 1直播中 2直播结束 3可回放
      if (this.liveStatus === 0) {
        result.liveText = '直播未开始'
      }
      if (this.liveStatus === 2) {
        result.liveText = '直播已结束'
      }

      return result
    },
    toHttps() {
      return function (url) {
        if (url.toString().indexOf('http://') >= 0) {
          url = url.toString().replace('http://', 'https://')
        }
        return url
      }
    },
    // 是否是小程序打开
    isMpOppen() {
      return getRequestAppType() === 'mp'
    },
  },
  mounted() {
    this.initTimCoinfg()
    this.initTimSdk()
  },
  methods: {
    // 显示app引导提示
    showAppSheetText(key) {
      this.appSheetTextKey = key
      this.$refs.ActionSheetApp.showAppSheet()
    },
    initTimCoinfg() {
      const imInfor = this.liveData.live || {}
      this.sdkAppID = imInfor.appid
      this.userSig = imInfor.im_user_sig
      this.userID = imInfor.im_identifier
      this.groupID = imInfor.chatroom_id
    },

    // 调整url
    toURL(url) {
      window.location.open(url)
    },
  },
}
</script>
<style lang="scss" scoped>
.wrappers {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.live-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  padding: 0.4rem;
  box-sizing: border-box;

  .teacher {
    display: flex;
    align-items: center;
    height: 0.91rem;
    background-color: rgba($color: #000000, $alpha: 0.2);
    border-radius: 0.48rem;
    padding: 0.08rem;
    box-sizing: border-box;
    width: max-content;
    font-size: 0;

    .img {
      width: 0.75rem;
      height: 0.75rem;
    }

    .text {
      font-size: 0.32rem;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 0rem;
      color: #ffffff;
      padding: 0 0.24rem 0 0.11rem;
    }
  }

  .button {
    @include flex_center;
    width: 2.67rem;
    height: 0.91rem;
    background: #ffffff;
    border-radius: 0.45rem;
    font-size: 0.32rem;
    font-weight: 500;
    color: #ff6a4d;
  }
}

.chat-list {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
  bottom: 1.8rem;
}
</style>
